<template>
    <div class="page">
        <div class="top">
            <div class="left">
                卡号 {{ recordLoginText }}
            </div>
            <div class="right">到期时间 {{ simInfo.endTimeString }}</div>
        </div>
        <div class="lx">
            <div class="lx-title">{{ simInfo.pkgName }}</div>
            <div class="lx-item">
                <div class="lx-item-fl">
                    <div class="num" v-if="simInfo.isNoLimitData == 1">无限量</div>
                    <div class="num" v-else>{{ fluxMtoG(simInfo.flowRate || 0) }}G</div>
                    <div class="name">总流量</div>
                </div>
                <div class="lx-item-fl bor">
                    <div class="num" v-if="simInfo.isNoLimitData == 1">无限量</div>
                    <div class="num" v-else>{{ fluxMtoG(simInfo.surplusFlowRate || 0) }}G</div>
                    <div class="name">剩余流量</div>
                </div>
                <div class="lx-item-fl">
                    <div class="num">{{ simInfo.cardStateName }}</div>
                    <div class="name">{{ isAuthName }}</div>
                </div>
            </div>
        </div>
        <div class="price" @click="toBalanceRecharge()">
            <div class="price-num">卡余额
                <div>{{ money_format(userAccount.amount / 100, 2, ".", ",") * 1 }}</div>
            </div>
            <img src="@/assets/she/icon23.png" alt="">
        </div>
        <div class="tc">
            <div class="tc-i" @click="toRecharge()">
                <div class="tc-name">充套餐</div>
                <div class="tc-sm-name">充值套餐去激活</div>
                <img src="@/assets/she/icon24.png" alt="">
            </div>
            <div class="tc-i tc-i-2"  @click="toBalanceRecharge()">
                <div class="tc-name">充余额</div>
                <div class="tc-sm-name">余额买套餐更优惠</div>
                <img src="@/assets/she/icon22.png" alt="">
            </div>
            <!-- <div class="tc-i tc-i-2" v-else @click="toLog()">
            <div class="tc-name">查记录</div>
            <div class="tc-sm-name">充值余额享优惠</div>
            <img src="@/assets/she/icon22.png" alt="">
        </div> -->
        </div>

        <!-- <div class="znzd">
        <div class="nnn">
            <div class="name">智能诊断</div>
            <div class="el-name">账户有问题？可一键诊断修复</div>
        </div>
        <div class="znzd-btn" @click="gotoView">去诊断</div>
    </div> -->
        <br />

        <div class="znzd">
            <div class="nnn">
                <div class="name">关注公众号更优惠</div>
                <div class="el-name">更多福利请关注公众号查收</div>
            </div>
            <div class="znzd-btn" @click="gongzhonghaoFlg = true">去关注</div>
        </div>

        <!-- <div class="box">常用操作</div> -->
        <div class="btn-item">
            <div class="btn-1">
                <div class="btn-items">
                    <img src="@/assets/she/icon06.png" alt="" @click="toKefuUrl">
                    <div class="btn-name">联系客服</div>
                </div>
                <div class="btn-items" v-if="simInfo.sheUrl && simInfo.sheUrl.length > 2">
                    <img src="@/assets/she/3.png" alt="" @click="toShebei">
                    <div class="btn-name">设备管理</div>
                </div>
                <div class="btn-items" v-else>
                    <img src="@/assets/she/icon13.png" alt="" @click="autoPkg">
                    <div class="btn-name">自动续费</div>
                </div>

                <div class="btn-items">
                    <img src="@/assets/she/icon17.png" alt="" @click="toActive">
                    <div class="btn-name">一键复机</div>
                </div>
                <div class="btn-items" @click="gotoView()">
                    <img src="@/assets/she/icon12.png" alt="">
                    <div class="btn-name">智能诊断</div>
                </div>
            </div>
            <div class="btn-1">
                <div class="btn-items">
                    <img src="@/assets/she/icon18.png" alt="" @click="buyCard">
                    <div class="btn-name">在线商城</div>
                </div>
                <div class="btn-items">
                    <img src="@/assets/she/icon14.png" alt="" @click="toSupplierAuth">
                    <div class="btn-name">实名认证</div>
                </div>
                <!-- <div class="btn-items">
                    <img src="@/assets/she/12.png" alt="" @click="toSelectMa">
                    <div class="btn-name">充值码</div>
                </div> -->
                <div class="btn-items">
                    <img src="@/assets/she/icon19.png" alt="" @click="toLog">
                    <div class="btn-name">充值记录</div>
                </div>
                <div class="btn-items">
                    <img src="@/assets/she/icon14.png" alt="" @click="pkgListVisible = true">
                    <div class="btn-name">在用套餐</div>
                </div>
            </div>

            <div class="btn-1">
                <div class="btn-items">
                    <img src="@/assets/she/icon19.png" alt="" @click="pkgListVisible1 = true">
                    <div class="btn-name">次月套餐</div>
                </div>
                <div class="btn-items" v-if="isChangeCard">
                    <img src="@/assets/she/icon15.png" alt="">
                    <div class="btn-name">换卡申请</div>
                </div>
                <div class="btn-items">
                    <img src="@/assets/she/icon16.png" alt="" @click="outLogin">
                    <div class="btn-name">退出登录</div>
                </div>
            </div>

        </div>

        <!-- <img src="@/assets/she/icon20.png" alt="" class="lxkh"  @click="toKefu()"/> -->


        <van-dialog v-model="isShowAuth" title="实名认证提示" :show-confirm-button="false">
            <div class="dialog-text">
                根据国家规定，手机卡需要进行实名认证，实名认证后方可使用。
            </div>
            <div class="dialog-text">
                如果您已操作实名认证，无需重复操作，重启手机后即可畅享网络。
            </div>
            <div class="btn-vis">
                <van-button type="primary" class="dialog-btn2" @click="cancelChange">取消</van-button>
                <van-button type="primary" class="dialog-btn3" @click="toSupplierAuth">立即实名</van-button>
            </div>
        </van-dialog>

        <van-dialog v-model="isChangeCard" title="换卡通知" :show-confirm-button="false">
            <div class="dialog-text">
                由于运营商系统故障，此卡已暂停使用，我司将给您更换网速更好的新卡使用。<br />
                旧卡套餐和余额 会自动转移新卡上。感谢您的理解和支持。
            </div>
            <div class="btn-vis">
                <van-button type="primary" class="dialog-btn2" @click="cancelChange">取消</van-button>
                <van-button type="primary" class="dialog-btn3" @click="toChangeCard">去换新卡</van-button>
            </div>
        </van-dialog>

        <van-dialog v-model="appshowimg" title="保存充值码" confirmButtonColor="#86de6b" confirmButtonText="知道了">
            <div style="font-size: 18px;padding-top:6px;text-align: center;font-weight: bold;">卡号 {{ simInfo.virtualNo }}
            </div>
            <img style="width: 100%" :src="imgUrl" />
            <div style="font-size: 14px;color:#999;padding-top:6px;text-align: center;">截图保存二维码,后期可直接扫码充值</div>
        </van-dialog>



        <van-dialog v-model="gongzhonghaoFlg" title="关注公众号" confirmButtonColor="#86de6b" confirmButtonText="已关注">
            <div style="font-size: 18px;padding-top:6px;text-align: center;font-weight: bold;">
            </div>
            <img style="width: 100%" src="@/assets/she/0.png" />
            <div style="font-size: 14px;color:#999;padding-top:6px;text-align: center;">长按二维码 即可识别关注公众号</div>
        </van-dialog>



        <!--  更多套餐信息  -->
        <van-popup v-model="pkgListVisible" closeable position="bottom" style="min-height: 35%; max-height: 75%">
            <div class="pkgList">
                <h3 v-show="simInfo.simPackageList[0]">当前套餐:</h3>
                <h3 v-show="!simInfo.simPackageList[0]" style="color: red">未订购可用套餐</h3>
                <ul>
                    <li v-for="item in simInfo.simPackageList" :key="item.id">
                        <p> {{ item.packageName }}</p>
                        <p v-if="item.stateName == '已充值'" style="color:#32C5E9">已充值</p>
                        <p v-else style="color:red">充值中</p>
                        <div>
                            <p>生效时间： {{ item.startTime }}</p>
                            <p v-if="new Date(getDateByTimeStr(item.endTime)[0], getDateByTimeStr(item.endTime)[1], getDateByTimeStr(item.endTime)[2], getDateByTimeStr(item.endTime)[3], getDateByTimeStr(item.endTime)[4], getDateByTimeStr(item.endTime)[5]) < new Date()"
                                style="color: red;">过期时间： {{ item.endTime }}</p>
                            <p v-else>过期时间： {{ item.endTime }}</p>
                        </div>
                    </li>
                </ul>
            </div>
        </van-popup>
        <van-popup v-model="pkgListVisible1" closeable position="bottom" style="min-height: 35%; max-height: 75%">
            <div class="pkgList">
                <h3 v-show="simInfo.simNextPackageList[0]">次月套餐:</h3>
                <h3 v-show="!simInfo.simNextPackageList[0]" style="color: red">未订购次月套餐</h3>
                <ul>
                    <li v-for="item in simInfo.simNextPackageList" :key="item.id">
                        <p> {{ item.packageName }}</p>
                        <p v-if="item.stateName == '已充值'" style="color:#32C5E9">已充值</p>
                        <p v-else style="color:red">充值中</p>
                        <div>
                            <p>生效时间： {{ item.startTime }}</p>
                            <p v-if="new Date(getDateByTimeStr(item.endTime)[0], getDateByTimeStr(item.endTime)[1], getDateByTimeStr(item.endTime)[2], getDateByTimeStr(item.endTime)[3], getDateByTimeStr(item.endTime)[4], getDateByTimeStr(item.endTime)[5]) < new Date()"
                                style="color: red;">过期时间： {{ item.endTime }}</p>
                            <p v-else>过期时间： {{ item.endTime }}</p>
                        </div>
                    </li>
                </ul>
            </div>
        </van-popup>

    </div>
</template>
<script>
import { wxRequest } from "@/api/user.js";
import { Toast, Dialog } from "vant";
export default {
    data() {
        return {
            gongzhonghaoFlg: false,
            pkgListVisible: false,
            pkgListVisible1: false,

            showYu: localStorage.getItem("showYu") == 0 ? true : false,
            showQie: false,
            showQieInx: '',
            dataForm: {

            },
            heightNum: 100,
            leftNum: 0,
            battery: 0, //电量
            deviceConnNum: 0, //链接人数
            deviceStatus: '', // 0离线 1 在线

            index: '1',
            inx: '1',
            wifiName: '',
            wifiPass: '',
            notifyContent: "上网卡不能更换卡槽，否则将会导致无法使用。如有疑问 请联系在线客服处理",
            showLoadTitle: localStorage.getItem("isShowApp") == 1 ? true : false,
            isShowLoad: localStorage.getItem("isShowApp"),
            newHomeImg: localStorage.getItem("newHomeImg"),
            newHomeUrl: localStorage.getItem("newHomeUrl"),
            isAuth: localStorage.getItem("isAuth"),
            isAgentLogin: localStorage.getItem("isAgentLogin"),
            yucun: localStorage.getItem("yucun"),
            isSale: localStorage.getItem("isSale"),
            shebeiLogin: localStorage.getItem("shebeiLogin"),
            ishavePkg: localStorage.getItem("ishavePkg"),
            ishavePrice: localStorage.getItem("ishavePrice"),
            kefuUrl: localStorage.getItem("kefuUrl"),
            isChangeCard: false,
            isAuthName: '未实名/未知', //实名状态
            isShowAuth: false,
            appshowimg: false,
            canChangeCard: false,
            userAccount: {},
            simInfo: {},
            show: false,
            reacheShow: false,
            reacheShows: false,
            isShow: true,
            iccid: localStorage.getItem('iccid'),
            recordLoginText: localStorage.getItem('recordLoginText'),
            isNewPage: localStorage.getItem('isNewPage'),
            alreadyHasAccount: false,
            ctccAuthShow: false,
            cmccXxtx: false,
            cuccAuthShow: false,
            cmccAuthShow: false,
            otherAuth: false,
            otherUrl: '',
            isShowPrice: false,
            isShowDiejiaQuan: false,
            isShowYueHuodong: false,
            appshowimg: false,
            imgUrl: '',
            ctcc5GAuth: false,
            ctccJieAuth: false,
            guangdianAuth: false,
            isDialogShow: false,
            phoneList: [],
            dialogIccid: "",
        }
    },
    async created() {
        // localStorage.setItem("iccid", "8888888888888877777777");
        // localStorage.setItem('recordLoginText', '8888888888888877777777');
        // this.$store.state.iccid = "8888888888888877777777";

        var oneFirstLogin = localStorage.getItem('oneFirstLogin')
        if (oneFirstLogin == 1) {
            var appid = "";
            await wxRequest("/sim/get/appId", {}, "get").then((res) => {
                if (res.data.code == 200) {
                    appid = res.data.data;
                    var redirectUrl = window.location.href;
                    var index = redirectUrl.indexOf("code");
                    redirectUrl = encodeURIComponent(redirectUrl);
                    if (index < 0) {
                        window.location.href = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${appid}&redirect_uri=${redirectUrl}&response_type=code&scope=snsapi_base#wechat_redirect`;
                    } else {
                        var search = window.location.search;
                        var startIndex = search.indexOf("code");
                        var endIndex = search.indexOf("&", startIndex);
                        var str = search.slice(startIndex, endIndex);
                        var code = str.slice(str.indexOf("=") + 1);
                        console.log('获取code=' + code + 'url:' + search);
                        let data = {
                            requestId: localStorage.getItem("iccid"),
                            code: code
                        }
                        wxRequest("sim/bindIccid", data, "get").then(res => {
                            if (res.data.code == '200') {
                                localStorage.setItem("oneFirstLogin", 2);
                                this.iniAllSelect();
                            } else {
                                this.$dialog.alert({ title: '提示', message: res.data.message });
                            }
                        });
                    }
                } else {
                    Dialog.alert({
                        title: '提示',
                        message: res.data.message
                    });
                }
            });
        } else {
            this.iniAllSelect();
        }


    },
    methods: {
        async iniAllSelect() {
            await this.getUserSimInfo();
            await wxRequest("wxAuth/ctcc/auth", { iccid: localStorage.getItem("iccid"), intoNo: localStorage.getItem("intoNo") }, "post").then((res) => {
                if (res.data.code == 200) {
                    this.isAuthName = "已实名";
                } else if (res.data.code == 302) {
                    this.isAuthName = "请先购买套餐";
                }
                sessionStorage.setItem("alreadyCertification", "true");
            });
            await this.getAccount();
            /**   换卡判断       **/
            let fd = new FormData();
            fd.append("iccid", localStorage.getItem("iccid"));
            await wxRequest("applyChangeSim/isChange", fd, "post").then((res) => {
                if (res.data.code == "200") { //换卡提醒
                    this.isChangeCard = true;
                    localStorage.setItem('isTochangeCard', 1)
                } else if (
                    this.isSale > 0 &&
                    this.ishavePkg == 0 &&
                    this.ishavePrice == 1 &&
                    this.isAuthName == '请先购买套餐'
                ) {
                    this.isShowPrice = true;
                } else if (this.isAuthName == '未实名/未知') {
                    this.isShowAuth = true;
                } else if (this.yucun == 1) {
                    this.isShowYueHuodong = true;
                } else if (this.yucun == 3) {
                    this.isShowDiejiaQuan = true;
                }
            });
        },

        toShebei() {
            window.location.href = this.simInfo.sheUrl;
        },
        toKefuUrl() {
            wxRequest("sim/kefu/url", { iccid: this.$store.state.iccid }, "post").then(res => {
                if (res.data.code == '200') {
                    window.location.href = res.data.data;
                } else {
                    Dialog.alert({
                        title: '提示',
                        message: res.data.message
                    });
                }
            })
        },

        getDateByTimeStr(timeStr) {
            if (timeStr && typeof (timeStr) === 'string') {
                let dayStr = timeStr.split(' ')[0].split('-');
                let hourStr = timeStr.split(' ')[1].split(':');
                return dayStr.concat(hourStr);
            }
            return timeStr;
        },

        tabsChange(i) {
            if (i == 3) {
                i = 1;
                this.index = i;
                window.location.href = this.simInfo.sheUrl
                return;
            }
            this.index = i;

        },
        mousedown(e) {
            const min = 80 // 底部安全阀值
            e.target.ontouchmove = (event) => {
                let value = Math.abs(window.innerHeight - event.touches[0].clientY)
                let value1 = Math.abs(window.innerWidth - event.touches[0].clientX)
                if (value < min) value = min
                if (value1 < min) value1 = min
                this.heightNum = value
                this.leftNum = value1
            }
        },
        mouseup() {
            e.target.onmousemove = null
        },
        bChange(i) {
            if (this.inx == i) {
                return;
            }
            if (i === '1') {
                if (this.dataForm.sysMap.in1AuthName == '未实名') {
                    Dialog.confirm({
                        message: "尊敬的用户你好，请先完成实名认证后 再进行切卡操作。如已完成实名认证 请稍后等待5分钟再试。",
                        confirmButtonText: "去实名",
                        cancelButtonText: "取消",
                    }).then(() => {
                        wxRequest("wxAuth/ctcc/to/5G/auth", { iccid: this.dataForm.sysMap.inIccid1, isCheckout: "sa" }, "post").then((res) => {
                            if (res.data.code == "200") {
                                window.location.href = res.data.data;
                            } else {
                                Dialog.alert({
                                    title: "提示",
                                    message: res.data.message,
                                });
                            }
                        });
                    }).catch(() => { });
                    return;
                }
            } else if (i === '2') {
                if (this.dataForm.sysMap.in2AuthName == '未实名') {
                    Dialog.confirm({
                        message: "尊敬的用户你好，请先完成实名认证后 再进行切卡操作。如已完成实名认证 请稍后等待5分钟再试。",
                        confirmButtonText: "去实名",
                        cancelButtonText: "取消",
                    }).then(() => {
                        window.location.href = 'http://wx.yunzhineng.top/#/user/cuccAuthUrl?iccid=' + this.dataForm.sysMap.inIccid2;
                    }).catch(() => { });
                    return;
                }
            }
            //  Dialog.alert({ title: "温馨提示", message: '功能即将上线，请后续关注公众号通知' });
            // this.inx = i
            this.showQieInx = i;
            this.showQie = true;
        },
        confirmQie() {
            var data = {
                iccid: localStorage.getItem("iccid")
            }
            if (this.showQieInx == 1) {
                data.cardSlot = this.dataForm.sysMap.in1Num
                data.newIccid = this.dataForm.sysMap.inIccid1
            } else if (this.showQieInx == 2) {
                data.cardSlot = this.dataForm.sysMap.in2Num
                data.newIccid = this.dataForm.sysMap.inIccid2
            }
            wxRequest("sim/update/shebei/qie", data, "post").then(res => {
                if (res.data.code === '200') {
                    this.inx = this.showQieInx;
                    this.showQie = false;
                    Dialog.alert({
                        title: '切换成功',
                        message: res.data.message
                    })
                    localStorage.setItem("iccid", data.newIccid);
                    this.iccid = data.newIccid;
                    //this.$router.push({ path: '/userNew/logins', query: {  } })
                } else {
                    Dialog.alert({
                        title: '温馨提示',
                        message: res.data.message
                    })
                }
            })
        },
        toUpdateWifi() {
            var data = {
                wifiName: this.wifiName,
                wifiPwd: this.wifiPass,
                iccid: localStorage.getItem("iccid")
            }
            wxRequest("sim/update/shebei/pwd", data, "post").then(res => {
                if (res.data.code === '200') {
                    Dialog.alert({
                        title: '修改成功',
                        message: res.data.message
                    })
                } else {
                    Dialog.alert({
                        title: '温馨提示',
                        message: res.data.message
                    })
                }
            })
            //Dialog.alert({ title: "温馨提示", message: '功能即将上线，请后续关注公众号通知' });
        },

        toKefu() {
            wxRequest("sim/kefu/url", { iccid: this.iccid }, "post").then(res => {
                if (res.data.code == '200') {
                    window.location.href = res.data.data;
                } else {
                    Dialog.alert({
                        title: '提示',
                        message: res.data.message
                    });
                }
            })
        },

        outLogin() {
            localStorage.removeItem('iccid');
            localStorage.removeItem('userPhone');
            // localStorage.removeItem('recordLoginText');
            this.$router.replace('/new/login');
        },

        selectIon(item, index) {
            this.inx = index
            this.dialogIccid = item.cardNo
        },
        sureToChange() {
            console.log(this.dialogIccid)
            let data = {
                requestId: this.dialogIccid,
                code: "1"
            };
            let recordLoginText = this.dialogIccid;
            wxRequest("sim/bind", data, "get").then((res) => {
                if (res.data.code == 200) {
                    this.isDialogShow = false
                    let record = res.data.data;
                    let iccid = record.iccid;
                    if (record.titleMap) {
                        localStorage.setItem("wxTitle", record.titleMap.title);
                        localStorage.setItem("wxText", record.titleMap.context);
                        localStorage.setItem("wxUrls", record.titleMap.urls);
                    } else {
                        localStorage.setItem("wxTitle", '');
                        localStorage.setItem("wxText", '');
                        localStorage.setItem("wxUrls", '');
                    }
                    localStorage.setItem('isNewPage', record.isNewPage);
                    this.$store.state.isNewPage = record.isNewPage;
                    localStorage.setItem('newHomeImg', record.newHomeImg);
                    localStorage.setItem('newHomeImg2', record.newHomeImg2);
                    localStorage.setItem('newHomeUrl', record.newHomeUrl);
                    localStorage.setItem("mobile", record.mobile);
                    localStorage.setItem("isBindPhone", record.isBindPhone);
                    localStorage.setItem("supplierTypeName", record.supplierTypeName);
                    localStorage.setItem("wxHeadImg", record.wxHeadImg);
                    localStorage.setItem("wxNickName", record.wxNickName);
                    localStorage.setItem("recordLoginText", recordLoginText);
                    localStorage.setItem("supplierName", record.supplierName);
                    localStorage.setItem("iccid", iccid);
                    localStorage.setItem("intoNo", record.intoNo);
                    localStorage.setItem("phoneNo", record.userPhone);
                    localStorage.setItem("userPhone", record.userPhone);
                    localStorage.setItem("openId", record.openId);
                    localStorage.setItem("agentId", record.agentId);
                    localStorage.setItem("flowRatePool", record.flowRatePool);
                    this.$store.state.recordLoginText = recordLoginText;
                    this.$store.state.supplierCode = res.data.data.supplierCode;
                    this.iccid = iccid;
                    this.$store.state.flowRatePool = res.data.data.flowRatePool;
                    this.$store.state.intoNo = record.intoNo;
                    if (record.isToYuCun != 1) {
                        this.$router.replace("/user/openPrice");
                    } else {
                        this.$router.replace('/new/home');
                    }
                } else {
                    Dialog.alert({ title: "提示", message: res.data.message });
                }
            });

        },
        toChangeSim() {
            wxRequest("she/select/changeList", { iccid: localStorage.getItem("iccid") }, "post").then((res) => {
                if (res.data.code == 200) {
                    this.phoneList = res.data.data;
                    this.isDialogShow = true;
                } else {
                    Dialog.alert({
                        message: res.data.message,
                    });
                }
            });
        },
        gotoView() {
            this.$router.push({
                path: '/user/diagnosis'
            })
        },
        cancelChange() {
            this.isShowYueHuodong = false,
                this.isShowAuth = false;
            this.isChangeCard = false;
            this.isShowPrice = false;
            this.isShowDiejiaQuan = false;
        },
        toChangeCard() {
            this.$router.push({
                name: "userChgCard",
                query: {
                    oldIccid: localStorage.getItem("iccid")
                },
            });
        },
        toLog() {
            this.$router.push({
                path: "/user/balanceRechargeRecord",
                query: {
                    iccid: this.iccid,
                },
            });
        },
        buyCard() {
            wxRequest("applyChangeSim/select/agent/buy/power", { oldIccid: localStorage.getItem("iccid") }, "post").then((res) => {
                if (res.data.code == 200) {
                    this.$router.push("/user/liuliangka?agentId=" + this.simInfo.agentId);
                } else {
                    Dialog.alert({
                        message: res.data.message,
                    });
                }
            });
        },
        toActive() {
            wxRequest("sim/to/active", { iccid: localStorage.getItem('iccid') }, 'get').then(res => {
                Dialog.alert({ message: res.data.message })
            })
        },
        toSelectMa() {
            wxRequest("sim/get/invent/ma", { iccid: this.iccid }, "post").then(res => {
                if (res.data.code == '200') {
                    if (res.data.data) {
                        this.imgUrl = res.data.data;
                        this.appshowimg = true;
                    }
                } else {
                    Dialog.alert({
                        title: '温馨提示',
                        message: res.data.message
                    });
                }
            })
        },
        autoPkg() {
            this.$router.push({ path: '/user/renew', query: { iccid: this.iccid } })
        },
        getUserSimInfo() {
            wxRequest("sim/detail", { iccid: this.iccid }, "post").then(
                (res) => {
                    if (res.data.code == 200) {
                        let result = res.data.data;
                        if (result.flowRatePool == "电信") {
                            this.ctccAuthShow = true;
                        } else if (result.flowRatePool == "电信接口") {
                            this.ctccJieAuth = true;
                        } else if (result.flowRatePool == "5G电信") {
                            this.ctcc5GAuth = true;
                        } else if (result.flowRatePool == "联通") {
                            this.cuccAuthShow = true;
                        } else if (result.flowRatePool == "前海") {
                            this.qianhaiSHow = true;
                        } else if (result.flowRatePool == "移动") {
                            this.cmccAuthShow = true;
                        } else if (result.flowRatePool == "乐语") {
                            this.leyuAuthShow = true;
                        } else if (result.flowRatePool == "移动接口") {
                            this.cmccXxtx = true;
                        } else if (result.flowRatePool == '广电') {
                            this.guangdianAuth = true;
                        } else {
                            this.otherUrl = result.flowRatePool;
                            this.otherAuth = true;
                        }
                        localStorage.setItem('simInfoMap', result);
                        sessionStorage.setItem("supplierCode", result.supplierCode);
                        this.simInfo = result;
                        if (result.simPackageList.length > 1) {
                            for (let i = 0; i < result.simPackageList.length; i++) {
                                if (
                                    result.simPackageList[i].flowRatePercent &&
                                    (result.simPackageList[i].flowRatePercent / 100) *
                                    result.simPackageList[i].flowRate >
                                    result.simPackageList[i].usedFlowRate
                                ) {
                                    this.simInfo.packageName =
                                        result.simPackageList[i].packageName;
                                    this.simInfo.endTime = result.simPackageList[i].endTime;
                                    break;
                                }
                            }
                        } else if (result.simPackageList.length == 1) {
                            this.simInfo.packageName = result.simPackageList[0].packageName;
                            this.simInfo.endTime = result.simPackageList[0].endTime;
                        }
                        this.simInfo.simId = this.simInfo.simPackageList[0]
                            ? this.simInfo.simPackageList[0].simId
                            : "";
                    }
                }
            );
        },
        getAccount() {
            let param = {
                iccid: this.iccid,
                mobile: localStorage.getItem("mobile"),
            };
            wxRequest("sysUser/account/querySysUserAccount", param, "post").then(
                (res) => {
                    if (res.data.code == 200) {
                        this.userAccount = res.data.data;
                        this.alreadyHasAccount = true;
                        localStorage.setItem("userSimAmount", this.userAccount.amount)
                        localStorage.setItem('alreadyHasAccount', 1);
                    } else {
                        localStorage.setItem("userSimAmount", 0);
                        localStorage.setItem('alreadyHasAccount', 0);
                    }
                }
            );
        },
        toSupplierAuth() {
            if (this.isAuthName == '已实名') {
                Dialog.alert({ title: "提示", message: '已完成实名认证，无需再次实名！' });
            } else if (this.isAuthName == '请先购买套餐') {
                Dialog.confirm({
                    message: "尊敬的用户你好，请先购买套餐后 再进行实名操作",
                    confirmButtonText: "去购买",
                    cancelButtonText: "取消",
                }).then(() => {
                    this.$router.replace('/new/package');
                })
                    .catch(() => { });
            } else {
                if (this.cmccXxtx == true) {
                    wxRequest(
                        "wxAuth/cmcc/auth",
                        { iccid: this.$store.state.iccid },
                        "post"
                    ).then((res) => {
                        if (res.data.code == "200") {
                            window.location.href = res.data.data;
                        } else {
                            Dialog.alert({
                                title: "提示",
                                message: res.data.message,
                            });
                        }
                    });
                } else if (this.ctccAuthShow == true) {
                    this.$router.push({
                        path: "/user/ctccAuth",
                        query: { realNameCard: 1 },
                    });
                } else if (this.cuccAuthShow == true) {
                    window.location.href = "http://wx.yunzhineng.top/#/user/cuccAuth";
                } else if (this.cmccAuthShow == true) {
                    this.$router.push({
                        path: "/user/cmccAuth",
                        query: { realNameCard: 1 },
                    });
                } else if (this.ctcc5GAuth == true) {
                    wxRequest(
                        "wxAuth/ctcc/to/5G/auth",
                        { iccid: this.$store.state.iccid },
                        "post"
                    ).then((res) => {
                        if (res.data.code == "200") {
                            window.location.href = res.data.data;
                        } else {
                            Dialog.alert({
                                title: "提示",
                                message: res.data.message,
                            });
                        }
                    });
                } else if (this.ctccJieAuth == true) {
                    wxRequest(
                        "wxAuth/ctcc/to/auth",
                        { iccid: this.$store.state.iccid },
                        "post"
                    ).then((res) => {
                        if (res.data.code == "200") {
                            window.location.href = res.data.data;
                        } else {
                            Dialog.alert({
                                title: "提示",
                                message: res.data.message,
                            });
                        }
                    });
                } else if (this.guangdianAuth == true) {
                    this.$router.push('/user/ctccGdAuth');
                }
                else {
                    window.location.href = this.otherUrl;
                }
            }
        },
        toRecharge() {
            let fd = new FormData();
            fd.append("supplierId", sessionStorage.getItem("supplierCode"));
            wxRequest("sim/invent/state", fd, "post").then((res) => {
                if (res.data.code == 200) {
                    if (this.userAccount.amount < 0) {
                        Dialog.confirm({
                            title: "提示",
                            message: "您的账户余额已透支，请先充值账户余额！",
                        })
                            .then(() => {
                                this.$router.push({
                                    path: "/new/balanceRecharge",
                                    query: {
                                        iccid: this.iccid,
                                    },
                                });
                            })
                            .catch(() => { });
                    } else {
                        this.$router.push({
                            path: "/she/sealMenu",
                            query: {
                                iccid: this.iccid,
                            },
                        });

                    }
                } else {
                    Dialog.alert({
                        title: "提示",
                        message: res.data.message,
                    });
                }
            });

        },
        toBalanceRecharge() {
            if (this.yucun == 1 || this.yucun == 888) {
                this.$router.push({
                    path: "/user/huodong",
                    query: {
                        iccid: this.iccid,
                    },
                });
            } else {
                this.$router.push({
                    path: "/she/balanceRecharge",
                    query: {
                        iccid: this.iccid,
                    },
                });
            }

        },
        toKefu() {
            wxRequest("sim/get/kefuUrl", {}, "post").then(res => {
                if (res.data.data) {
                    window.location.href = res.data.data;
                } else {
                    Dialog.alert({ title: "提示", message: '客服即将上线！如有其它疑问，请点一点诊断中寻找帮助' });
                }
            })
        },
    }
}
</script>
<style lang="less" scoped>
.page {
    background: linear-gradient(180deg, #3980F9 0%, rgba(247, 250, 255, 0) 30%), #F6F9FF;
    padding: 0 14px;
    height: 100vh;

    .top {
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 16px 0;
        font-family: PingFangSC, PingFang SC;

        .left {
            font-size: 16px;
            color: #fff;
            display: flex;
            align-items: center;
            font-weight: 600;
            line-height: 22px;

            .copy_btn {
                margin-left: 10px;
                padding: 2px 8px;
                color: white;
                font-weight: 100;
                cursor: pointer;
                margin-left: 9px;
            }
        }

        .right {
            line-height: 17px;
            font-size: 12px;
            color: #fff;
        }
    }

    .lx {
        padding: 16px 12px 21px;
        background: url('~@/assets/she/icon11.png') no-repeat center center;
        background-size: 100% 100%;

        .lx-title {
            font-family: PingFangSC, PingFang SC;
            font-weight: 600;
            font-size: 16px;
            color: #343434;
            line-height: 22px;
        }

        .lx-item {
            display: flex;
            justify-content: space-between;
            align-items: center;
            margin-top: 16px;
            font-family: PingFangSC, PingFang SC;

            .lx-item-fl {
                text-align: center;
                flex: 1;

                .num {
                    font-family: DIN, DIN;
                    font-weight: bold;
                    font-size: 22px;
                    color: #343434;
                    line-height: 27px;
                }

                .name {
                    font-family: PingFangSC, PingFang SC;
                    font-weight: 400;
                    font-size: 14px;
                    color: #343434;
                    line-height: 20px;
                    margin-top: 6px;
                }
            }

            .bor {
                border-left: 1px solid #343434;
                border-right: 1px solid #343434;
            }
        }
    }

    .price {
        margin: 8px 0 10px;
        background: linear-gradient(90deg, #FFF7EA 0%, #FED499 100%);
        border-radius: 10px;
        border: 1px solid;
        border-image: linear-gradient(90deg, rgba(255, 224, 182, 1), rgba(255, 202, 128, 1)) 1 1;
        padding: 15px 10px 15px 24px;
        display: flex;
        align-items: center;
        justify-content: space-between;

        .price-num {
            font-family: PingFangSC, PingFang SC;
            font-size: 14px;
            color: #343434;
            line-height: 24px;
            display: flex;
            align-items: center;

            div {
                margin-left: 6px;
                color: #FD734D;
                font-family: DIN, DIN;
                font-weight: bold;
                font-size: 22px;
            }
        }

        img {
            width: 44px;
            height: 44px;
        }
    }

    .tc {
        display: flex;
        justify-content: space-between;
        align-items: center;

        .tc-i {
            width: 43%;
            background: #E0EBFF;
            padding: 14px 10px 34px;
            border-radius: 10px;
            position: relative;

            .tc-name {
                font-family: PingFangSC, PingFang SC;
                font-weight: 600;
                font-size: 18px;
                color: #4A84E8;
            }

            .tc-sm-name {
                font-family: PingFangSC, PingFang SC;
                font-weight: 400;
                font-size: 12px;
                color: #88AEF2;
                margin-top: 8px;
            }

            img {
                width: 67px;
                height: 54px;
                position: absolute;
                bottom: 5px;
                right: 6px;
            }
        }

        .tc-i-2 {
            background: #FFEBE2;

            .tc-name {
                color: #F35E12;
            }

            .tc-sm-name {
                color: #F89767;
            }
        }
    }

    .box {
        font-family: PingFangSC, PingFang SC;
        font-weight: 600;
        font-size: 16px;
        color: #343434;
        margin: 10px 15px 13px;
        line-height: 22px;
    }

    .btn-item {
        margin-top: 20px;
        border-radius: 10px;
        padding: 19px 0;
        font-family: PingFangSC, PingFang SC;

        .btn-1 {
            display: flex;
            align-items: center;
            width: 100%;
            margin-bottom: 18px;

            .btn-items {
                /* flex: 1; */
                display: flex;
                justify-content: center;
                align-items: center;
                flex-direction: column;
                width: 25%;

                img {
                    width: 50px;
                    /* 设置图片宽度 */
                    height: 50px;
                    /* 设置图片高度 */
                    margin-bottom: 5px;
                    /* 设置图片与文字之间的间距 */
                }

                .btn-name {
                    font-size: 12px;
                    /* 设置文字大小 */
                    color: #333333;
                    /* 设置文字颜色 */
                }
            }
        }
    }

    .znzd {
        display: flex;
        align-items: center;
        background: url('~@/assets/she/1.png') no-repeat center center;
        background-size: 100% 100%;
        padding: 16px 0;

        .nnn {
            width: 70%;
            padding-left: 110px;

            .name {
                font-family: PingFangSC, PingFang SC;
                font-weight: 600;
                font-size: 16px;
                color: #343434;
            }

            .el-name {
                font-family: PingFangSC, PingFang SC;
                font-weight: 400;
                font-size: 14px;
                color: #999999;
                margin-top: 8px;
            }
        }

        .znzd-btn {
            width: 30%;
            height: 40px;
            background: #397EF5;
            border-radius: 20px;
            color: #fff;
            font-family: PingFangSC, PingFang SC;
            font-size: 14px;
            line-height: 38px;
            text-align: center;
            margin-left: auto;
            margin-right: 16px;
        }
    }

    .lxkh {
        width: 50px;
        height: 50px;
        position: fixed;
        right: 13px;
        bottom: 30px;
        z-index: 9999;
        border-radius: 50%;
        cursor: pointer;
    }
}

.van-dialog {
    ::v-deep.van-dialog__content {
        flex-direction: column;
        justify-content: center;
        background-color: #fff;
        padding: 20px;
        border-radius: 10px;
    }

    ::v-deep .van-dialog__header {
        font-size: 20px;
        font-weight: 700;
        color: #06121e;
        text-align: center;
        margin-bottom: 10px;
    }

    .dialog-text {
        font-size: 14px;
        color: #06121e;
        margin-top: 8px;
        line-height: 28px;
    }

    .btn-vis {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        margin-top: 25px;

        .dialog-btn2 {
            width: 120px;
            height: 47px;
            color: #3B2C1D;
            text-align: center;
            background: rgba(52, 118, 254, 0.1) !important;
            border: 0 !important;
            border-radius: 94px;
            font-size: 16px;
            line-height: 47px;
        }

        .dialog-btn3 {
            width: 130px;
            height: 47px;
            border-radius: 94px;
            font-size: 16px;
            line-height: 47px;
            border: 0;
            color: #fff;
            background: #3B2C1D;
            text-align: center;
        }
    }
}

.pkgList {
    padding: 10px 20px;

    h3 {
        margin-top: 20px;
        font-size: 14px;
        line-height: 28px;
        font-weight: bold;
    }

    ul {
        line-height: 38px;

        li {
            display: flex;
            justify-content: space-between;
            margin-bottom: 15px;

            >p {
                display: flex;
                align-items: center;
            }

            >div {

                p {
                    line-height: 18px;
                    font-size: 12px;
                }
            }
        }
    }
}
</style>